// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiBaseUrl: 'http://localhost:3001/api',
  // apiBaseUrl: 'http://172.28.34.10:3001/api',
  //apiBaseUrl: 'http://10.0.0.9:3001/api',
  apiBaseUrl: '/customer/api',
  //apiBaseUrl: 'https://ytyconnect.com/customer/api',
  // apiBaseUrl: 'https://medisafeconnect.com/test/api',
  //cmsBaseUrl: 'https://ytyhub.com/api',
  cmsBaseUrl: 'https://ytyconnect.com/strapi/',
  isMedisafe: false,
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
